const initials = "report/";

export const UPDATE_DASHBOARD_DATA = `${initials}UPDATE_DASHBOARD_DATA`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;